import script from "./ClothingStore.vue?vue&type=script&setup=true&lang=js"
export * from "./ClothingStore.vue?vue&type=script&setup=true&lang=js"

import "./ClothingStore.vue?vue&type=style&index=0&id=3773e679&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3773e679"]])

export default __exports__